import script from "./TheHeaderHelp.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheHeaderHelp.vue?vue&type=script&setup=true&lang=ts"

import "./TheHeaderHelp.vue?vue&type=style&index=0&id=f5206b66&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5206b66"]])

export default __exports__